var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { managementService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from '~/core/decorator';
var ResourceService = /** @class */ (function () {
    function ResourceService() {
    }
    /**
     * 获取全部资源信息
     */
    ResourceService.prototype.getResourceAll = function () {
        return this.netService.send({
            server: managementService.resourceController.getResourceAll
        });
    };
    ResourceService.prototype.getResourceAllPage = function (resource, page) {
        return this.netService.send({
            server: managementService.resourceController.getResourceAllPage,
            data: resource,
            page: page
        });
    };
    ResourceService.prototype.createResource = function (data) {
        return this.netService.send({
            server: managementService.resourceController.createResource,
            data: data,
            loading: true,
        });
    };
    ResourceService.prototype.deleteResourceById = function (id) {
        return this.netService.send({
            server: managementService.resourceController.deleteResourceById,
            data: {
                id: id
            }
        });
    };
    __decorate([
        Inject(NetService)
    ], ResourceService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], ResourceService.prototype, "getResourceAll", null);
    __decorate([
        Debounce()
    ], ResourceService.prototype, "getResourceAllPage", null);
    __decorate([
        Debounce()
    ], ResourceService.prototype, "createResource", null);
    __decorate([
        Debounce()
    ], ResourceService.prototype, "deleteResourceById", null);
    return ResourceService;
}());
export { ResourceService };
